// When making changes to these interfaces, please update the documentation here: https://aka.ms/transcriptionwordwebfileformat

import { IRecordingEvent } from "../manager/RecordingEventManager/RecordingEventManager";

/*For any change in IStoredTransctiption schema, TRANSCRIPT_STORAGE_VERSION, defined in
TransctionManagerFactory, should be updated.*/
export type StoredTranscriptionDescriptor = any;

export enum TranscriptionStorageType {
    DocumentStorage = 'DocumentStorage'
}

export interface IStoredTranscription {
    storageType: TranscriptionStorageType,
    recording_time_stamps?: IRecordingEvent[],
    descriptor: StoredTranscriptionDescriptor
}